import { aspenApiConfig, AspenApiConfigInterface } from '@om1/aspen-api'
import { trackingConfig, TrackingConfigInterface } from '@om1/platform-tracking'
import React, { PropsWithChildren } from 'react'
import { AspenAuth0Config, aspenAuth0Config } from './aspen-auth0-config'
import { aspenConfig, AspenConfigInterface } from './aspen-config'

// any provider or package needing environment variables get initialized here
export interface ConfigInterface extends TrackingConfigInterface, AspenApiConfigInterface, AspenAuth0Config, AspenConfigInterface {}

export const UACConfigContext = React.createContext<Partial<ConfigInterface>>({})

export const Config: React.FunctionComponent<PropsWithChildren<{ config: ConfigInterface }>> = ({ children, config }) => {
    const validatedConfig = {
        ...config
    }
    return <UACConfigContext.Provider value={validatedConfig}>{children}</UACConfigContext.Provider>
}

export const config: ConfigInterface = { ...trackingConfig, ...aspenApiConfig, ...aspenAuth0Config, ...aspenConfig }
